<template>
  <div class="container">
    <el-container>
      <el-main>
        <div>
          <el-dialog class="invoicenext bgwhite" :visible.sync="dialogTableVisible" :close-on-click-modal="false" :before-close="beforeClose">
            <el-row class="collapsenext">
              <el-col :span="18">
                <el-form ref="form" :model="invoiceInformation" label-width="110px" :rules="rules">
                  <el-form-item label="普通类型：" prop="invoiceUnit" style="margin-bottom: 0px;">
                    <el-radio-group v-model="invoiceInformation.invoiceUnit" @change="selectUnit">
                      <el-radio :label="1">个人或事业单位</el-radio>
                      <el-radio :label="0">企业</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="发票形式：" prop="billingType">
                    <el-radio-group v-model="invoiceInformation.billingType">
                      <el-radio :label="1" >电子发票</el-radio>
                      <el-radio :label="2">纸质发票</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="发票类型：" prop="invoiceType" style="margin-bottom: 0px;">
                    <el-radio-group v-model="invoiceInformation.invoiceType" @change="changeInvoiceType">
                      <el-radio :label="0">增值税普通发票</el-radio>
                      <el-radio :label="1" v-if='invoiceInformation.invoiceUnit==0'>增值税专用发票</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="发票抬头：" style="width:200px" prop="invoiceName"
                                class="addressF">
                    <el-input v-model="invoiceInformation.invoiceName" style="width:330px;height:38px"
                              placeholder="请填写抬头">
                    </el-input>

                  </el-form-item>
                  <div>
                    <div v-show="unfoldNext">
                      <el-form-item label="纳税识别号：" class="addressF" prop="taxId">
                        <el-input v-model="invoiceInformation.taxId" style="width:330px;height:38px"
                                  placeholder="请填写纳税识别号">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="开户银行：" style="width:200px" prop="bankAccount">
                        <el-input v-model="invoiceInformation.bankAccount" style="width:330px;height:38px"
                                  placeholder="请填写开户银行" maxlength="30">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="银行账号：" style="width:200px" prop="bankAccounts">
                        <el-input v-model="invoiceInformation.bankAccounts"
                                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                                  style="width:330px;height:38px"
                                  placeholder="请填写银行账号" maxlength="20">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="企业地址：" style="width:200px" prop="address">
                        <el-input v-model="invoiceInformation.address" style="width:330px;height:38px"
                                  placeholder="请填写企业地址" maxlength="255">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="企业电话：" style="width:200px" prop="phone">
                        <el-input v-model="invoiceInformation.phone" style="width:330px;height:38px"
                                  placeholder="请填写企业电话：" maxlength="30">
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <el-form-item>
                    <el-checkbox v-model="invoiceInformation.isDefault" :true-label="1" :false-label="0"
                                 class="addressp">
                      设为默认抬头
                    </el-checkbox>
                  </el-form-item>
<!--                  <el-form-item>-->
<!--                   -->
<!--                  </el-form-item>-->
                </el-form>
              </el-col>
            </el-row>
            <div v-if="invoiceInformation.billingType == '2' ">
              <div class="poTitle">发票邮寄地址</div>
              <el-form ref="formAddr" :rules="rulesAddr" :model="invoiceInformation" label-width="110px">
                <el-form-item label="申请人：" >
                  <el-input placeholder="请填写申请人信息" v-model="invoiceInformation.memberName" style="width:330px;height:38px"></el-input>
                </el-form-item>
                <el-form-item label="联系电话："  >
                  <el-input placeholder="请填写联系电话" v-model="invoiceInformation.contactNumber" style="width:330px;height:38px"></el-input>
                </el-form-item>
                <el-form-item label="公司地址：">
                  <el-input placeholder="请填写公司地址" v-model="invoiceInformation.companyAddress" style="width:330px;height:38px"></el-input>
                </el-form-item>
                <el-form-item  label="详细地址：">
                  <el-input placeholder="请填写详细地址" v-model="invoiceInformation.emailAddress" style="width:330px;height:38px"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button v-if="isAdd" @click="saveInvoiceInfo()" >
                {{ saveBtn }}
              </el-button>
              <el-button v-else @click="update">{{ saveBtn }}</el-button>
            </div>
          </el-dialog>
          <div>
            <div style="margin-bottom: 20px; padding-bottom: 5px;border-bottom: 1px solid #EBEEF5">
              <el-button type="primary" size="mini" @click="dialogTableVisible = true,isAdd=true">新增</el-button>
            </div>
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="个人发票" name="1">
                <el-table
                  :data="personageInvoiceData"
                  align="center"
                  border
                  :header-cell-style="{textAlign:'center'}"
                  style="width: 100%">
                  <el-table-column
                    prop="date"
                    label="发票信息"
                  >
                    <template slot-scope="scope">
                      <el-row :gutter="20">
                        <el-col :span="10">发票类型：{{ scope.row.invoiceType == 0 ? '普通发票' : '专用发票' }}</el-col>
                        <el-col :span="10"> 发票抬头:{{ scope.row.invoiceName }}</el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="175px"
                  >
                    <template slot-scope="scope">
                      <el-button type="primary" size="small" @click="updateInvoiceInfo(scope.row)">修改</el-button>
                      <el-button type="danger" size="small" @click="deleteInvoiceInfo(scope.row.id)">删除</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    width="175px"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.isDefault==1">默认发票抬头</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block">
                  <el-pagination
                    background
                    @current-change="queryPersonage"
                    :page-size="pageInfo.size"
                    layout="prev, pager, next, jumper"
                    :total="pageInfo.total">
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="企业发票" name="0">
                <el-table
                  :data="companyInvoiceData"
                  border
                  style="width: 100%">
                  <el-table-column
                    prop="date"
                    label="发票信息"
                  >
                    <template slot-scope="scope">
                      <el-row :gutter="10">
                        <el-col :span="10">发票类型：{{ scope.row.invoiceType == 0 ? '普通发票' : '专用发票' }}</el-col>
                        <el-col :span="10">发票抬头:{{ scope.row.invoiceName }}</el-col>
                        <el-col :span="10">纳税识别号:{{ scope.row.taxId }}</el-col>
                        <el-col :span="10" v-if="scope.row.bankAccount!=null && scope.row.bankAccount!=''">
                          {{ '开户银行:' + scope.row.bankAccount }}
                        </el-col>
                        <el-col :span="10" v-if="scope.row.bankAccounts!=null && scope.row.bankAccounts!=''">
                          {{ '银行账号:'+ scope.row.bankAccounts }}
                        </el-col>
                        <el-col :span="10" v-if="scope.row.phone!=null && scope.row.phone!=''">
                          {{ '企业电话:'+scope.row.phone }}
                        </el-col>
                        <el-col :span="10" v-if="scope.row.address!=null && scope.row.address!=''">
                          {{ '企业地址:'+scope.row.address }}
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="175px"
                  >
                    <template slot-scope="scope">
                      <el-button type="primary" size="small" @click="updateInvoiceInfo(scope.row)">修改</el-button>
                      <el-button type="danger" size="small" @click="deleteInvoiceInfo(scope.row.id)">删除</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    width="175px"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.isDefault==1">默认发票抬头</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block">
                  <el-pagination
                    background
                    @current-change="queryCompany"
                    :page-size="companyPage.size"
                    layout="prev, pager, next, jumper"
                    :total="companyPage.total">
                  </el-pagination>
                </div>
              </el-tab-pane>
            </el-tabs>

          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
import {mapGetters} from 'vuex'

export default {
  mixins: [listSearchMixin],
  data () {
    return {
      rules: {
        invoiceUnit: [
          {required: true, message: '请选择发票类型', trigger: 'blur'}
        ],
        invoiceType: [
          {required: true, message: '请选择发票类型', trigger: 'blur'}
        ],
        invoiceName: [
          {required: true, message: '请填写发票抬头', trigger: 'blur'}
        ]
      },

      rulesAddr: {
        memberName: [
          { required: true, message: '请填写申请人信息', trigger: 'blur' }
        ],
        contactNumber: [
          // {validator: checkContactNumber, trigger: 'blur'}
          { required: true, message: '请填写联系电话', trigger: 'blur' }
        ],
        companyAddress: [
          { required: true, message: '请填写公司地址', trigger: 'blur' }
        ],
        emailAddress: [
          { required: true, message: '请填写详细地址', trigger: 'blur' }
        ]
      },

      personage: {
        invoiceUnit: [
          {required: true, message: '请选择发票类型', trigger: 'blur'}
        ],
        invoiceType: [
          {required: true, message: '请选择发票类型', trigger: 'blur'}
        ],
        invoiceName: [
          {required: true, message: '请填写发票抬头', trigger: 'blur'}
        ]
      },
      company: {
        taxId: [
          {required: true, message: '请填写纳税识别号', trigger: 'blur'}
        ]
      },
      unitType: {
        invoiceUnit: [
          {required: true, message: '请选择发票类型', trigger: 'blur'}
        ],
        invoiceType: [
          {required: true, message: '请选择发票类型', trigger: 'blur'}
        ],
        invoiceName: [
          {required: true, message: '请填写发票抬头', trigger: 'blur'}
        ],
        taxId: [
          {required: true, message: '请填写纳税识别号', trigger: 'blur'}
        ],
        bankAccount: [
          {required: true, message: '请填写开户银行', trigger: 'blur'}
        ],
        bankAccounts: [
          {required: true, message: '请填写银行账号', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请填写企业地址', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请填写企业电话', trigger: 'blur'}
        ]
      },
      isAdd: true,
      activeName: '1',
      dialogTableVisible: false,
      personageInvoiceData: [],
      companyInvoiceData: [],
      saveBtn: '保存',
      unfoldNext: false,
      isCompany: true,
      // 发票信息表单
      invoiceInformation: {
        address: '',
        bankAccount: '',
        bankAccounts: '',
        // idCard: '',
        invoiceName: '',
        invoiceType: 0,
        invoiceUnit: 1,
        billingType: 1,
        contactNumber: null,
        memberName: null,
        companyAddress: null,
        emailAddress: null,
        isDefault: 1,
        phone: '',
        taxId: '',
        id: null
      },
      companyPage: {
        current: 1,
        size: 5,
        total: 1
      },
      pageInfo: {
        current: 1,
        size: 5,
        total: 1
      }
    }
  },
  created () {
    this.invoiceRecords()
  },
  computed: {
    ...mapGetters([
      'userInfo' // 用户信息
    ])
  },
  methods: {
    queryPersonage (e) {
      this.pageInfo.current = e
      this.invoiceRecords()
    },
    queryCompany (e) {
      this.companyPage.current = e
      this.invoiceRecords()
    },
    changeInvoiceType () {
      let self = this
      if (self.invoiceInformation.invoiceUnit === 0) {
        self.unfoldNext = true
        if (self.invoiceInformation.invoiceType === 0) {
          self.rules = self.personage
          self.rules.taxId = self.company.taxId
          self.$refs.form.clearValidate()
        } else {
          self.rules = self.unitType
          self.$refs.form.clearValidate()
        }
      } else {
        self.unfoldNext = false
        self.rules = self.personage
      }
    },
    selectUnit () {
      let self = this
      if (self.invoiceInformation.invoiceUnit === 0) {
        self.unfoldNext = true
        self.rules = Object.assign({}, self.personage)
        self.rules.taxId = Object.assign([], self.company.taxId)
        self.$refs.form.clearValidate()
      } else {
        self.unfoldNext = false
        self.invoiceInformation.invoiceType = 0
        self.rules = Object.assign({}, self.personage)
        self.$refs.form.clearValidate()
      }
    },
    beforeClose () {
      let self = this
      this.dialogTableVisible = false
      self.invoiceInformation = {
        address: '',
        bankAccount: '',
        bankAccounts: '',
        invoiceName: '',
        invoiceType: 0,
        billingType: 1,
        contactNumber: null,
        memberName: null,
        companyAddress: null,
        emailAddress: null,
        invoiceUnit: self.invoiceInformation.invoiceUnit,
        isDefault: 1,
        phone: '',
        taxId: ''
      }
    },
    handleClick () {
      let self = this
      this.invoiceInformation.invoiceUnit = Number(this.activeName)
      if (self.invoiceInformation.invoiceUnit === 0) {
        self.unfoldNext = true
      } else {
        self.unfoldNext = false
      }
      this.invoiceRecords()
    },
    updateInvoiceInfo (data) {
      this.invoiceInformation = Object.assign({}, data)
      this.dialogTableVisible = true
      if (this.invoiceInformation.invoiceUnit === 0) {
        this.unfoldNext = true
      } else {
        this.unfoldNext = false
      }
      this.isAdd = false
    },
    deleteInvoiceInfo (id) {
      let self = this
      let params = {
        url: api.delInvoiceInfo + '?id=' + id,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.data) {
          self.$message({
            message: '操作成功',
            type: 'success'
          })
          self.invoiceRecords()
        } else {
          self.$message({
            message: '删除失败',
            type: 'warning'
          })
        }
      })
    },
    invoiceRecords () {
      let self = this
      let page = {}
      if (self.invoiceInformation.invoiceUnit === 0) {
        page = self.companyPage
      } else {
        page = self.pageInfo
      }
      let params = {
        url: api.invoiceInfoRecords + '?page=' + page.current + '&size=' + page.size,
        method: 'POST',
        data: {
          invoiceUnit: self.invoiceInformation.invoiceUnit
        }
      }
      self.sendReq(params, (res) => {
        if (self.invoiceInformation.invoiceUnit === 0) {
          self.companyInvoiceData = res.data.data
          self.companyPage.total = res.data.total
        } else {
          self.personageInvoiceData = res.data.data
          self.pageInfo.total = res.data.total
        }
      })
    },
    update () {
      let self = this
      if (!this.checkForm()) {
        self.$message({
          message: '请填写完整信息',
          type: 'warning'
        })
        return
      }
      // if (!this.checkForm1()) {
      //   self.$message({
      //     message: '请填写完整信息',
      //     type: 'warning'
      //   })
      //   return
      // }
      let params = {}
      if (self.invoiceInformation.invoiceUnit === 1) {
        params = {
          url: api.updInvoiceInfo,
          method: 'POST',
          data: {
            id: self.invoiceInformation.id,
            invoiceUnit: self.invoiceInformation.invoiceUnit,
            invoiceType: self.invoiceInformation.invoiceType,
            invoiceName: self.invoiceInformation.invoiceName,
            isDefault: self.invoiceInformation.isDefault,
            billingType: self.invoiceInformation.billingType,
            memberName: self.invoiceInformation.memberName,
            contactNumber: self.invoiceInformation.contactNumber,
            companyAddress: self.invoiceInformation.companyAddress,
            emailAddress: self.invoiceInformation.emailAddress
          }
        }
      } else {
        params = {
          url: api.updInvoiceInfo,
          method: 'POST',
          data: self.invoiceInformation
        }
      }
      self.sendReq(params, (res) => {
        if (res.data) {
          self.dialogTableVisible = false
          self.$message({
            message: '操作成功',
            type: 'success'
          })
          self.invoiceInformation = {
            address: '',
            bankAccount: '',
            bankAccounts: '',
            invoiceName: '',
            invoiceType: 0,
            billingType: self.invoiceInformation.billingType,
            memberName: self.invoiceInformation.memberName,
            contactNumber: self.invoiceInformation.contactNumber,
            companyAddress: self.invoiceInformation.companyAddress,
            emailAddress: self.invoiceInformation.emailAddress,
            invoiceUnit: self.invoiceInformation.invoiceUnit,
            isDefault: 1,
            phone: '',
            taxId: ''
          }
          this.activeName = '' + self.invoiceInformation.invoiceUnit
          self.invoiceRecords()
        } else {
          self.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    checkForm () {
      let validForm = false
      this.$refs.form.validate(valid => { validForm = valid })
      if (!validForm) {
        return false
      }
      return true
    },
    // checkForm1 () {
    //   let validForm = false
    //   this.$refs.formAddr.validate(valid => { validForm = valid })
    //   if (!validForm) {
    //     return false
    //   }
    //   return true
    // },
    saveInvoiceInfo () {
      let self = this
      if (!this.checkForm()) {
        self.$message({
          message: '请填写完整信息',
          type: 'warning'
        })
        return
      }
      // if (!this.checkForm1()) {
      //   self.$message({
      //     message: '请填写完整信息',
      //     type: 'warning'
      //   })
      //   return
      // }

      let params = {}
      if (self.invoiceInformation.invoiceUnit === 1) {
        params = {
          url: api.saveInvoiceInfo,
          method: 'POST',
          data: {
            id: self.invoiceInformation.id,
            invoiceUnit: self.invoiceInformation.invoiceUnit,
            invoiceType: self.invoiceInformation.invoiceType,
            invoiceName: self.invoiceInformation.invoiceName,
            isDefault: self.invoiceInformation.isDefault,
            billingType: self.invoiceInformation.billingType,
            memberName: self.invoiceInformation.memberName,
            contactNumber: self.invoiceInformation.contactNumber,
            companyAddress: self.invoiceInformation.companyAddress,
            emailAddress: self.invoiceInformation.emailAddress
          }
        }
      } else {
        params = {
          url: api.saveInvoiceInfo,
          method: 'POST',
          data: self.invoiceInformation
        }
      }
      self.sendReq(params, (res) => {
        if (res.data) {
          self.dialogTableVisible = false
          self.$message({
            message: '操作成功',
            type: 'success'
          })
          let active = '' + self.invoiceInformation.invoiceUnit
          self.invoiceInformation = {
            address: '',
            bankAccount: '',
            bankAccounts: '',
            invoiceName: '',
            invoiceType: 0,
            billingType: self.invoiceInformation.billingType,
            memberName: self.invoiceInformation.memberName,
            contactNumber: self.invoiceInformation.contactNumber,
            companyAddress: self.invoiceInformation.companyAddress,
            emailAddress: self.invoiceInformation.emailAddress,
            invoiceUnit: self.invoiceInformation.invoiceUnit,
            isDefault: 1,
            phone: '',
            taxId: ''
          }
          self.activeName = active
          self.invoiceRecords()
        } else {
          self.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  border: 1px solid #E5E5E5;
  .el-row {
    width: 890px;
    margin-bottom: 20px;
    border-bottom: none !important;
    font-size: 15px;
    color: #99a9bf;
    padding-bottom: 10px;
  }
  .el-col {
    text-align: left !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/invoice/invoiceInfo.vue